__turbopack_context__.v({
  "Danger": "more-options-modal-module__iJUbvW__Danger",
  "Divider": "more-options-modal-module__iJUbvW__Divider",
  "ModalContent": "more-options-modal-module__iJUbvW__ModalContent",
  "OptionItem": "more-options-modal-module__iJUbvW__OptionItem",
});
